// @refresh reset
import { useInitialize } from '@/hooks/useInitialize';
import { ScrollView, Target } from '@nandorojo/anchor';
import { Slot } from "expo-router";
import { lazy, Suspense } from 'react';

const Template = lazy(() => import('@/template'))

function Root () {
    
    useInitialize();
    
    const backgroundColor = 'light.100';
    
    return (
        <ScrollView
            style={{flex: 1, backgroundColor}}
            scrollEventThrottle={50}
            id='MAINSTAGE'
        >
            <Target name="page.top" />
            <Suspense fallback={null}>
                <Template>
                    <Slot />
                </Template>
            </Suspense>
            
        </ScrollView>
    );
}

export default Root;